<div class="login-content">
    <div class="login-content__footer">
        <div class="login-content__footer__button" #focus>
            <app-button
                    [ariaLabel]="('GENERAL.GET_STARTED' | translate) + ('GENERAL.BUTTON' | translate)"
                    [tabindex]="1"
                    [cssClasses]="'btn regular solid__blue-07 full-width'"
                    [icon]="'arrow_forward'"
                    (buttonClicked)="onLoginClick()">
                {{ 'GENERAL.GET_STARTED' | translate }}
            </app-button>
        </div>
    </div>
</div>

